<template>
  <div class="row">
    <div class="col-md-12">
    <ValidationObserver ref="form" >
     <b-form @submit.prevent="update">
          <Loading :active="loading" :full-page="true"></Loading>
          <label class="mr-sm-2" for="select-quota">
            Dolar a Pesos MXN:
          </label>
         <ValidationProvider name="usd" rules="required" v-slot="{ validated, valid }" class="ml-auto">
            <b-form-input
              id="usd"
              v-model="usd"
              type="text"
              :state="getState(validated, valid)"
              placeholder="Pesos $ MXN"
              class="ml-auto"
            ></b-form-input>
          </ValidationProvider>
          <a class="small" target="_blank" href="https://www.google.com/search?q=mxn+a+usd"> <font-awesome-icon :icon="['fas', 'external-link-alt']" /> Consultar tipo de cambio (MXN a USD)</a>
          <label class="d-block  mt-4" for="select-quota">
            <font-awesome-icon :icon="['fas', 'money-bill-wave']"/>
            Dolar a Dolar Canadiense CAD:
          </label>
          <ValidationProvider name="cad" rules="required" v-slot="{ validated, valid }" class="ml-auto">
            <b-form-input
              id="cad"
              v-model="cad"
              type="text"
              :state="getState(validated, valid)"
              placeholder="Canadienses $ CAD"
              class="ml-auto"
            ></b-form-input>
          </ValidationProvider>
          <a class="small" target="_blank" href="https://www.google.com/search?q=cad+a+usd"> <font-awesome-icon :icon="['fas', 'external-link-alt']" /> Consultar tipo de cambio (CAD a USD)</a>
          <label class="d-block  mt-4" for="select-quota">
            <font-awesome-icon :icon="['fas', 'euro-sign']" />
            Dolar a Euros EUR:
          </label>
          <ValidationProvider name="eur" rules="required" v-slot="{ validated, valid }" class="ml-auto">
            <b-form-input
              id="eur"
              v-model="eur"
              type="text"
              :state="getState(validated, valid)"
              placeholder="Euros $ EUR"
              class="ml-auto"
            ></b-form-input>
          </ValidationProvider>
          <a class="small" target="_blank" href="https://www.google.com/search?q=eur+a+usd"> <font-awesome-icon :icon="['fas', 'external-link-alt']" /> Consultar tipo de cambio (EUR a USD)</a>
          <b-alert v-if="errors" v-model="showErrors" dismissible variant="danger" class="mt-3">
            <ul class="m-0">
              <template v-for="field in errors">
                <li v-for="(m, index) in field" :key="index" class="text-danger">{{ m }}</li>
              </template>
            </ul>
          </b-alert>
          <b-alert v-model="updateSuccess" dismissible variant="success" class="mt-3">
            Los tipos de cambio se actualizaron correctamente
          </b-alert>
          <b-button type="submit" variant="primary" class="mt-3 col-md-12"><font-awesome-icon :icon="['fas', 'comment-dollar']"/>  Guardar tipo de cambio</b-button>
        </b-form>
    </ValidationObserver>
    </div>
  </div>
</template>
<script>
  import {NumberFormat} from "../../helpers/NumberFormat"
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
  import { required } from 'vee-validate/dist/rules'
  extend('required', required)
  export default {
    name:'ChangeCurrency',
    components:{FontAwesomeIcon, ValidationObserver, ValidationProvider},
    props:['currencies'],
    data() {
      return {
        errors:null,
        loading:false,
        modalQuota:false,
        showErrors: false,
        selectedItem:null,
        updateSuccess: null,
        eur:null,
        usd:null,
        cad:null,
        loading:false,
        tableHead: [
          { key: 'id', label: 'ID' },
          { key: 'code', label: 'Code' },
          { key: 'exchange', label: 'Tipo de Cambio' },  
          { key: 'name', label:'Divisa'}
        ]
      }
    },
    methods:{
       getClassState(state) {
        if (state === null) {
          return ''
        }
        if (state) {
          return 'valid'
        } else {
          return 'is-invalid'
        }
      },
      getState(validated, valid, error = undefined) {
        if (!validated || error) {
          return null;
        }
        return valid
      },
      numberFormat(num) {      
        let n = num || 0 
        return NumberFormat.format(parseFloat(n), 2, ',', '.')
      },
      urlReservation(item) {
        const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/reservations`
        return url+'/'+item.id
      },
      getCommission(reservation) {
        return parseFloat(reservation.total) - (parseFloat(reservation.base_total) + parseFloat(reservation.quota))
      },
      getDataToSave(){
        let data = {
          usd: this.usd,
          eur: this.eur,
          cad: this.cad,
        }
        return data
      },
      async update(e) {
        e.preventDefault()
        this.errors = null
       
      await this.$refs.form.validate().then((success) => {
       if (success) {
        const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/currency/update`
          const data = this.getDataToSave()
          this.loading = true
          this.showErrors = false
           return this.$axios.post(url,data).then(rs => {
            this.updateSuccess = true
            this.loading = false
            const newurl = `${process.env.MIX_APP_URL}${this.$prefixPanel}/currency`
            if (!rs.data.error) {
                setTimeout(() => window.location.href = newurl +'/', 1000);
            }else{
              this.showErrors = true
            }
          })
            .catch(error=> {
            this.showErrors = true
            if (error.response) {
              this.errors = error.response.data.errors
            }  else {
              this.errors = {
                unexpected: ['Hubo un error por favor contacte al administrador']
              }
            }
          console.log('error update', error);
          this.loading = false
          })
        }
       })
      },
      numberFormat(number) {
        return NumberFormat.format(parseFloat(number), 2, ',', '.')
      },
      getZoneName(zone){
        if (zone == 'foreign') {
          return 'Foraneo'
        }
        return 'Local'
      }
    }
  }
</script>